"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var buffer_1 = require("buffer");

var tweetnacl_1 = require("tweetnacl");

var CotterPublicKey = "qqOaiQGjGsxBMgI5rdAasaACRiJthOqadmefjY5mS/c=";

exports.ValidateToken = function (message, signature) {
  var messageUint8 = new Uint8Array(buffer_1.Buffer.from(message, "utf8"));
  var signatureUint8 = new Uint8Array(buffer_1.Buffer.from(signature, "base64"));
  var pubKeyUint8 = new Uint8Array(buffer_1.Buffer.from(CotterPublicKey, "base64"));
  return tweetnacl_1.sign.detached.verify(messageUint8, signatureUint8, pubKeyUint8);
};